<template>
  <div>
    <el-card shadow="never" class="aui-card--fill">
      <el-row style="margin-bottom:10px;">
        <el-col :span="4">
          <el-button @click="refreshDataList()" size="small">刷新</el-button>
          <el-button type="primary" @click="addOrUpdateHandle()" size="small">{{
            $t('add')
          }}</el-button>
        </el-col>
      </el-row>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        @sort-change="dataListSortChangeHandle"
        style="width: 100%;"
        max-height="400"
        :cell-style="cellStyle"
        :row-style="rowStyle"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
      <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
        ></el-table-column>
        <el-table-column
          prop="dictName"
          :label="$t('dict.dictName')"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="dictType"
          :label="$t('dict.dictType')"
          header-align="center"
          align="center"
        >
        </el-table-column>
        <el-table-column
          v-if="dataForm.pid !== '0'"
          prop="dictValue"
          label="字典值"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sort"
          :label="$t('dict.sort')"
          sortable="custom"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          :label="$t('dict.remark')"
          header-align="center"
          align="center"
        ></el-table-column>

        <el-table-column
          :label="$t('handle')"
          header-align="center"
          align="center"
          width="200"
        >
          <template slot-scope="scope">
            <el-button @click="addChild(scope.row)" type="text" size="small"
              >添加下级</el-button
            >
            <el-button
              v-if="$hasPermission('sys:dict:update')"
              type="text"
              size="small"
              @click="addOrUpdateHandle(scope.row)"
              >{{ $t('update') }}</el-button
            >
            <el-button
              v-if="$hasPermission('sys:dict:delete')"
              type="text"
              size="small"
              @click="deleteHandle(scope.row.id)"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update
        v-if="addOrUpdateVisible"
        ref="addOrUpdate"
        @refreshDataList="refreshDataList"
      ></add-or-update>
    </el-card>
    <ChildrenList :pid="pid" ref="childrenList"></ChildrenList>
  </div>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'
import ChildrenList from './children-list.vue'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      cellStyle: {
        padding: '4px',
      },
      rowStyle: {
        height: '10px',
      },
      pid: '',
      mixinViewModuleOptions: {
        activatedIsNeed: true,
        getDataListURL: '/sys/dict/page',
        getDataListIsPage: true,
        deleteURL: '/sys/dict',
        deleteIsBatch: true,
      },
      dataForm: {
        pid: '0',
        dictName: '',
        dictType: '',
        dictValue: '',
      },
    }
  },
  components: {
    AddOrUpdate,
    ChildrenList,
  },
  methods: {
    refreshDataList() {
      this.getDataList()
      this.$refs.childrenList.getDataList()
    },
    addChild(row) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.id = ''
        this.$refs.addOrUpdate.init()
        this.$nextTick(() => {
          this.$refs.addOrUpdate.dataForm.pid = row.id
          this.$refs.addOrUpdate.dataForm.dictType = row.dictType
        })
      })
    },
    handleCurrentChange(row) {
      if (!row) {
        return
      }
      this.pid = row.id
    },
    // 新增 / 修改
    addOrUpdateHandle(row = {}) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.id = row.id
        this.$refs.addOrUpdate.init()
      })
    },
    beforeTableBinding(dataList) {
      if (!dataList) {
        return
      }
      dataList.forEach((item) => {
        this.$http.get(`/sys/dict/list`, { dictType: item.name })
      })
    },
  },
}
</script>
